module.exports = __webpack_public_path__ + "img/mail-icon.d878e282.png";